
import { Component, Mixins } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import { SystemModule } from "@/store/modules";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class TruckStatusSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  get options() {
    return systemModule.truckStatuses.map(x => ({ label: x.code, value: x.code }));
  }
}
